export default __webpack_public_path__ + "static/malgorzatar-0bc40250bb5d19ac077acbdf77f3400b.png";